import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Input component with consistent styling
 */
const Input = React.forwardRef(({
    className,
    type = 'text',
    error,
    ...props
}, ref) => (
    <input
        type={type}
        className={cn(
            'input-field',
            {
                'border-error-500 focus:border-error-500 focus:ring-error-500': error,
            },
            className
        )}
        ref={ref}
        {...props}
    />
));

Input.displayName = 'Input';

/**
 * Textarea component
 */
const Textarea = React.forwardRef(({
    className,
    error,
    ...props
}, ref) => (
    <textarea
        className={cn(
            'input-field resize-none',
            {
                'border-error-500 focus:border-error-500 focus:ring-error-500': error,
            },
            className
        )}
        ref={ref}
        {...props}
    />
));

Textarea.displayName = 'Textarea';

/**
 * Label component
 */
const Label = React.forwardRef(({
    className,
    ...props
}, ref) => (
    <label
        ref={ref}
        className={cn(
            'form-label',
            className
        )}
        {...props}
    />
));

Label.displayName = 'Label';

/**
 * FormGroup component for consistent form field spacing
 */
const FormGroup = React.forwardRef(({
    className,
    children,
    ...props
}, ref) => (
    <div
        ref={ref}
        className={cn(
            'form-group',
            className
        )}
        {...props}
    >
        {children}
    </div>
));

FormGroup.displayName = 'FormGroup';

export { Input, Textarea, Label, FormGroup };